/**
 * Spillguard API Doc
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ChamberMaintenanceStatus =
  | 'Unknown'
  | 'New'
  | 'Ongoing'
  | 'Cleared'
  | 'MaintenanceRequired';

export const ChamberMaintenanceStatus = {
  Unknown: 'Unknown' as ChamberMaintenanceStatus,
  New: 'New' as ChamberMaintenanceStatus,
  Ongoing: 'Ongoing' as ChamberMaintenanceStatus,
  Cleared: 'Cleared' as ChamberMaintenanceStatus,
  MaintenanceRequired: 'MaintenanceRequired' as ChamberMaintenanceStatus,
};
